// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/app-info-component-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    title: {
      type: 'string',
      nullable: true,
    },
    version: {
      type: 'string',
      nullable: true,
    },
    healthEndpoint: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
